/* Cabinet Screws - accessibility panel behaviour.
 *
 * The preferences themselves are applied by the inline boot script in
 * snippets/cs-a11y.liquid, which runs before the page paints. This file only
 * wires the controls, so if it is slow or blocked the user still gets the
 * settings they saved last time - just without the panel to change them.
 *
 * Storage is wrapped in try/catch throughout: private mode and blocked
 * third-party storage both throw on access, not on write, and an exception
 * here would take out every later listener on the page.
 */
(function () {
  'use strict';

  var KEY = 'cs-a11y';
  var DEFAULTS = { ts: 1, contrast: false, motion: false, ground: false };
  var prefs = Object.assign({}, DEFAULTS);

  function load() {
    try {
      var j = JSON.parse(localStorage.getItem(KEY) || '{}');
      Object.keys(DEFAULTS).forEach(function (k) {
        if (k in j) prefs[k] = j[k];
      });
    } catch (e) { /* defaults are fine */ }
  }
  function save() {
    try { localStorage.setItem(KEY, JSON.stringify(prefs)); } catch (e) {}
  }

  function apply() {
    var r = document.documentElement;
    r.style.setProperty('--ts', prefs.ts);
    if (prefs.contrast) r.setAttribute('data-contrast', 'high');
    else r.removeAttribute('data-contrast');
    r.setAttribute('data-motion', prefs.motion ? 'off' : 'on');
    r.setAttribute('data-ground', prefs.ground ? 'bone' : 'white');
    paint();
    save();
  }

  function $(s) { return document.querySelector(s); }
  function $$(s) { return Array.prototype.slice.call(document.querySelectorAll(s)); }

  function paint() {
    $$('#cs-a11y [data-ts]').forEach(function (b) {
      b.setAttribute('aria-pressed',
        String(Number(b.getAttribute('data-ts')) === Number(prefs.ts)));
    });
    [['#cs-tg-contrast', 'contrast'], ['#cs-tg-motion', 'motion'],
     ['#cs-tg-ground', 'ground']].forEach(function (pair) {
      var el = $(pair[0]);
      if (el) el.setAttribute('aria-pressed', String(!!prefs[pair[1]]));
    });
  }

  function init() {
    var panel = $('#cs-a11y');
    var btn = $('#cs-a11y-btn');
    if (!panel || !btn) return;

    load();
    apply();

    /* Move the trigger into the utility bar.
     *
     * The mockups are explicit that this is NOT a floating circle: the bottom
     * right is tawk.to and the bottom left is the Google reviews badge, and
     * both are position:fixed on the live store. So the trigger belongs in the
     * toolbar. If no mount point is found the button keeps its own fixed
     * position rather than disappearing. */
    /* Put the trigger in the header icon row, next to the account person,
     * on every breakpoint.
     *
     * --in-bar stays on in both branches: cs-a11y.css uses
     * :not(.cs-a11y-btn--in-bar) as the "no mount point was found" fallback
     * that turns the trigger into a fixed floating button, and a floating
     * circle is the one thing the mockups ruled out.
     *
     * place() runs TWICE and is idempotent, because <shopify-account> is a
     * Shopify-injected custom element that is NOT queryable when this runs -
     * the first version of this patch appended the button to the far right of
     * the row on every page for exactly that reason. insertBefore moves a node
     * that is already placed, so the second call just corrects the first. */
    function place() {
      var nav = document.querySelector('.site-nav__icons');
      if (!nav) {
        var bar = document.querySelector('.toolbar__content');
        if (bar) { bar.appendChild(btn); btn.classList.add('cs-a11y-btn--in-bar'); }
        return false;
      }
      btn.classList.add('cs-a11y-btn--in-bar', 'cs-a11y-btn--in-nav');
      /* ordered by how reliably each is in the DOM, not by preference:
         toggle-cart is authored in the header Liquid and is never injected. */
      var anchor = nav.querySelector('shopify-account') || nav.querySelector('toggle-cart');
      if (anchor) { nav.insertBefore(btn, anchor); return true; }
      nav.appendChild(btn);
      return false;
    }
    /* Do not guess at a time - watch for the element.
     *
     * The header lives in an <is-land>, so `.site-nav__icons` exists before
     * its children do, and how far before differs per page: retrying on
     * `window load` fixed the PDP at 390 and home at 1440 and left home and
     * the cart at 390 still appended to the far right. A MutationObserver
     * cannot be early or late. It disconnects as soon as an anchor is found,
     * and gives up after 10s - by which point place() has already appended the
     * button, so the trigger is reachable either way. */
    if (!place() && window.MutationObserver) {
      var box = document.querySelector('.header-item--icons') || document.body;
      var mo = new MutationObserver(function () { if (place()) mo.disconnect(); });
      mo.observe(box, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 10000);
    }

    function close(focus) {
      panel.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      if (focus) btn.focus();
    }

    btn.addEventListener('click', function () {
      var open = panel.hidden === false;
      panel.hidden = open;
      btn.setAttribute('aria-expanded', String(!open));
      if (!open) {
        var first = panel.querySelector('.cs-a11y-seg button');
        if (first) first.focus();
      }
    });

    var closeBtn = $('#cs-a11y-close');
    if (closeBtn) closeBtn.addEventListener('click', function () { close(true); });

    $$('#cs-a11y [data-ts]').forEach(function (b) {
      b.addEventListener('click', function () {
        prefs.ts = Number(b.getAttribute('data-ts'));
        apply();
      });
    });

    [['#cs-tg-contrast', 'contrast'], ['#cs-tg-motion', 'motion'],
     ['#cs-tg-ground', 'ground']].forEach(function (pair) {
      var el = $(pair[0]);
      if (!el) return;
      el.addEventListener('click', function () {
        prefs[pair[1]] = !prefs[pair[1]];
        apply();
      });
    });

    var reset = $('#cs-a11y-reset');
    if (reset) reset.addEventListener('click', function () {
      prefs = Object.assign({}, DEFAULTS);
      apply();
    });

    /* Escape closes it, and focus goes back to the trigger rather than to the
     * top of the document. */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) close(true);
    });

    /* A click outside closes it. The trigger is excluded or its own click
     * would close and immediately reopen. */
    document.addEventListener('click', function (e) {
      if (panel.hidden) return;
      if (panel.contains(e.target) || btn.contains(e.target)) return;
      close(false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
